import { createSlice } from "@reduxjs/toolkit";
import { getChefRatesAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getChefRatesSlice = createSlice({
  name: "getChefRates",
  initialState: data,
  reducers: {
   getChefRatesSlice(state) {
      state.isLoading = true;
    },
   getChefRatesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefRatesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getChefRatesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefRatesHandler: any = () => async (dispatch: any) => {
  try {
    dispatch(getChefRatesAction.getChefRatesSlice());
    const response: any = await getChefRatesAPI();
    
    dispatch(getChefRatesAction.getChefRatesSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefRatesAction.getChefRatesSliceFailure(e?.response?.data));
  }
};
export default getChefRatesSlice.reducer;
export const getChefRatesAction = getChefRatesSlice.actions;
